import React, {PropTypes, Component} from 'react'
import { QUANTITY_NAME_S } from 'data/constants'


class LessonStatusTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    studentInfo: PropTypes.object.isRequired
  }

  render(){
    let {studentInfo} = this.props
    const {
      usedTotalQuantity,
      paidTotalQuantity,
      class_feeType,
      classStudentFeeState,
      days_left} = studentInfo

    if(class_feeType == 0){
      let status = __('Remaining ', 'classdetail')
      let newDaysLeft = days_left
      if(days_left < 0){
        // status = __('Overdue ', 'classdetail')
        newDaysLeft = 0
      }
      return (
        <div className='student-lesson-status'>
          {status + newDaysLeft + ' ' + QUANTITY_NAME_S[class_feeType]}
        </div>
      )
    } else {
      return(
        <div className='student-lesson-status'>
          {usedTotalQuantity + "/" + paidTotalQuantity + ' ' + QUANTITY_NAME_S[class_feeType]}
        </div>
      )
    }


  }
}

export default (LessonStatusTd)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/StudentTable/LessonStatusTd.js